/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

export { setLocale } from "./setLocale";
export { setTeamId } from "./setTeamId";
export { setTheme } from "./setTheme";
export { setTimeZone } from "./setTimeZone";
